<template>
  <!-- เมนูกระบวนการครูผู้ช่วย — ใช้ AssistantTeacherProcessNav ตัวเดียวกับ assistant_teacher_bar.vue -->
  <AssistantTeacherProcessNav />
</template>

<script>
import AssistantTeacherProcessNav from "./AssistantTeacherProcessNav.vue";

export default {
  name: "HRvecManageAssistantTeacherBar",
  components: { AssistantTeacherProcessNav }
};
</script>
